(function () {
  'use strict';
  function initCustomMap(root) {
    var custom = root.querySelector('[data-map-custom]');
    if (!custom) return;
    var editor = custom.querySelector('[data-map-custom-editor]');
    var host = custom.querySelector('[data-map-custom-native-host]');
    var summary = custom.querySelector('[data-map-custom-summary]');
    var summaryValue = custom.querySelector('[data-map-custom-value]');
    var edit = custom.querySelector('[data-map-custom-edit]');
    var apply = custom.querySelector('[data-map-custom-apply]');
    var scope = root.closest('.product-section') || document;
    var field, observer, editing = false, wasCustom = false;
    function isCustom() {
      var selected = root.querySelector('input[data-variant-input]:checked');
      return !!(selected && /^custom\b/i.test(selected.value));
    }
    function sync() {
      var selected = isCustom();
      var value = field ? field.value.trim() : '';
      if (selected && !wasCustom) editing = !value;
      wasCustom = selected;
      custom.hidden = !selected || !field;
      if (!field) return;
      // IO's container-scoped dependency updates do not cover the relocated
      // field. Keep its value, but submit/share it only for the Custom variant.
      if (field.disabled !== !selected) field.disabled = !selected;
      if (selected) {
        if (field.name !== 'properties[Pick a map]') field.name = 'properties[Pick a map]';
        field.removeAttribute('name-disabled');
      }
      var expanded = editing || !value;
      editor.hidden = !expanded;
      summary.hidden = expanded;
      summaryValue.textContent = value;
      summaryValue.title = value;
      edit.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    function attachField() {
      field = scope.querySelector('textarea[name="properties[Pick a map]"], textarea[name-disabled="properties[Pick a map]"]');
      var row = field && field.closest('.push_pin_map_pick_map, .io-card, .not_same_line');
      if (!row) return false;
      // Move the original control, retaining its explicit form association,
      // property name, value and Infinite Options validation hooks.
      var form = field.form;
      var parent = row.parentNode, next = row.nextSibling;
      host.appendChild(row);
      if (form && field.form !== form) {
        parent.insertBefore(row, next);
        field = null;
        return false;
      }
      row.setAttribute('data-map-custom-native', '');
      var label = row.querySelector('label');
      if (label) label.textContent = 'Which map would you like?';
      var help = row.querySelector('.spb-helptext');
      if (!help) {
        help = document.createElement('div');
        help.className = 'spb-helptext';
      }
      help.textContent = "Paste a product link, or describe the map you're looking for.";
      field.parentNode.insertBefore(help, field);
      field.placeholder = '';
      field.addEventListener('input', sync);
      field.addEventListener('change', sync);
      if (observer) observer.disconnect();
      sync();
      return true;
    }
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-variant-input]')) sync();
    });
    document.addEventListener('variant:change', sync);
    window.addEventListener('um:pdp-configuration-restored', function () {
      editing = false;
      sync();
    });
    apply.addEventListener('click', function () {
      if (!field) return;
      if (!field.value.trim()) { field.focus(); return; }
      editing = false;
      field.dispatchEvent(new Event('change', {bubbles: true}));
      sync();
      edit.focus({preventScroll: true});
    });
    edit.addEventListener('click', function () {
      editing = true;
      sync();
      if (field) field.focus({preventScroll: true});
    });
    if (!attachField()) {
      observer = new MutationObserver(function () { attachField(); });
      observer.observe(scope, {childList: true, subtree: true});
    }
  }
  function init() {
    document.querySelectorAll('[data-pdp-map-choice-selector]').forEach(function (root) {
      if (root.dataset.mapChoiceBound === 'true') return;
      root.dataset.mapChoiceBound = 'true';
      var toggle = root.querySelector('[data-map-choice-toggle]');
      if (!toggle) return;
      function setExpanded(expanded) {
        root.setAttribute('data-map-choice-collapsed', expanded ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Show fewer maps' : 'Show more maps';
      }
      // Direct variant links and restored configurations may select an extra.
      function revealSelected() {
        if (root.querySelector('[data-map-choice-extra] input:checked')) setExpanded(true);
      }
      setExpanded(false);
      revealSelected();
      toggle.hidden = false;
      toggle.addEventListener('click', function () { setExpanded(toggle.getAttribute('aria-expanded') !== 'true'); });
      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-variant-input]')) revealSelected();
      });
      var section = root.closest('[data-product-id]');
      document.addEventListener('variant:change', function (event) {
        if (!section || !event.target.closest || event.target.closest('[data-product-id]') === section || event.target === document) revealSelected();
      });
      window.addEventListener('um:pdp-configuration-restored', revealSelected);
      initCustomMap(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
